import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import lang from './lang';
import vuetify from './plugins/vuetify';
import startup from './startup';
import 'lodash';
import './filters';
import './directives';
import './components';
import './scss/main.scss';

Vue.config.productionTip = false;
Vue.prototype._ = window._;
Vue.prototype.$console = console;
Vue.prototype.$lang = lang;
Vue.observable(lang);

startup(store, router, (user) => {
  if (user) store.commit('LOGIN', user);

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
  }).$mount('#app');
});
